import OrdersService from "../../../services/orders.service";
import ShippingService from "../../../services/shippings.service";
import CloseoutService from "../../../services/closeout.service";
import OrderTagsService from "../../../services/order-tags.service";
import OrderStatusesService from "../../../services/order-statuses.service";
import ExtraStatusService from "../../../services/extra-status.service";

import EventBus from "../../../EventBus";
import { debounce } from "debounce";
import _ from "lodash";

export default {
  methods: {
    sleep(milliseconds) {
      const date = Date.now();
      let currentDate = null;
      do {
        currentDate = Date.now();
      } while (currentDate - date < milliseconds);
    },
    fetchOrders(orderOpenState = []) {
      this.isBusy = true;

      OrdersService.fetchStoreOrders(this.data)
        .then((response) => {
          this.orders = response.data.data.rows.map((order, index) => {
            let selectedObj = this.orderIdsForApiShippingRequest.includes(
              order.id
            )
              ? {
                  selected: `yes-${order.id}-${order.order_no}`,
                }
              : {
                  selected: `no-${order.id}-${order.order_no}`,
                };

            return {
              ...order,
              ...selectedObj,
              ...{
                itemsVisible: orderOpenState[index]
                  ? orderOpenState[index]
                  : false,
                index: index + 1,
                shippingValidationError: false,
              },
            };
          });

          this.data.count = response.data.data.count;
          this.updateSelectAll();
          this.getStoreWiseStatuses(this.data.store_id);
        })
        .catch((error) => {
          this.errors =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        })
        .then(() => {
          this.isBusy = false;
          this.showOrHideTags();
        });
    },
    showOrHideTags() {
      if (this.showTags) {
        this.showAllTags("show");
      } else {
        this.showAllTags("hide");
      }
    },
    // if all records are in selected state, the selectAll must be checked
    updateSelectAll() {
      this.selectAll = "yes";
      this._.forEach(this.orders, (order) => {
        if (order.selected == `no-${order.id}-${order.order_no}`) {
          this.selectAll = "no";
          return false;
        }
      });
    },
    fetchStoreData(data) {
      this.data.store_id = data.store_id;
      this.data.searchTerm = data.searchTerm ? data.searchTerm : null;
      this.data.statusSelected = data.statusSelected
        ? data.statusSelected
        : null;

      this.data.extraStatuses = data.extraStatuses;
      this.data.ordersListId = null;
      this.data.page = 1;
      this.fetchOrders();
    },
    updatePerPageRecord(count) {
      this.data.pageSize = count;
      if (this.data.store_id) {
        this.fetchOrders();
      }
    },
    fetchWithAdvancedFilters(filterData) {
      this.data.created_start_date = filterData.created_start_date;
      this.data.created_end_date = filterData.created_end_date;
      this.data.processingMethod = filterData.shipping_type;
      this.data.referringSite = filterData.conversion_source;
      this.data.page = 1;
      this.data.count = 0;
      if (this.data.store_id) {
        this.fetchOrders();
      }
    },
    showDetails(details) {
      EventBus.$emit("show-orders-details", details);
    },
    toggleSelectAll(select_status) {
      this.orders.forEach((order) => {
        order.selected = `${select_status}-${order.id}-${order.order_no}`;
      });
      if (select_status == "no") {
        let tempOrderArr = [];
        this.orders.forEach((order) => {
          tempOrderArr.push(order.id);
        });
        this.$store
          .dispatch("orders/removeFromOrdersShipping", tempOrderArr)
          .then(() => {
            console.log("Order removed for shipping to DHL");
          });
      }
    },
    addForShipping() {
      this.orderForShipping = [];
      this.orderForShipping = this.orders.filter((order) => {
        if (order.selected == `yes-${order.id}-${order.order_no}`) {
          return order;
        }
      });

      // Validate field before sending shipping for dhl
      let validate = { good: true, ids: [] };
      this.orderForShipping.forEach((order, indexOrder) => {
        if (
          !order.incoterm ||
          !order.dhlService ||
          !order.weightTakenAfterPackaging ||
          !order.packageDesc
        ) {
          validate.good = false;
          validate.ids.push(order.id);
        } else {
          order.ShopifyOrderItems.forEach((item, indexItem) => {
            if (!item.hsCode || !item.setPrice) {
              validate.good = false;
              validate.ids.push(order.id);
            }
          });
        }
      });

      // Open up the fields that are invalid. Also show error indicator
      if (!validate.good) {
        this.orders.forEach((order) => {
          if (validate.ids.includes(order.id)) {
            order.itemsVisible = true;
            order.shippingValidationError = true;
          } else {
            order.itemsVisible = false;
          }
        });

        // Also show an error message
        this.$toasted.show(
          "Missing Data. Please fill the missing fields before continuing",
          {
            type: "error",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
      }

      // If no errors found. send for shippping
      if (validate.good) {
        this.orderForShipping = this.orderForShipping.map((order) => {
          return {
            id: order.id,
            shopify_store_id: order.shopify_store_id,
            order_no: order.order_no,
          };
        });

        this.$store
          .dispatch("orders/addOrdersForShipping", this.orderForShipping)
          .then(() => {
            console.log(
              "orders added for shipping",
              this.$store.state.orders.ordersForShipping
            );
            this.$toasted.show("Order added for shipping", {
              action: {
                text: "Cancel",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log("Couldn't add orders for shipping");
            this.$toasted.show("You can't add more than 100 records at once", {
              type: "error",
              action: {
                text: "Cancel",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
          });
      }
    },

    isRecordSelected(value) {
      let tempOrderArr = [];

      let valAndId = value.split("-");
      let selected = valAndId[0];
      let id = parseInt(valAndId[1]);
      let orderNo = valAndId[2];
      // manually also update the particular order selected.
      this._.forEach(this.orders, (order) => {
        if (order.id == id) {
          order.selected = `no-${order.id}-${order.order_no}`;
        }
      });

      // so if selected is no and the id is included in the shipping request just remove it.
      // when this request is happening the
      if (selected == "no" && this.orderIdsForApiShippingRequest.includes(id)) {
        tempOrderArr.push(id);
        this.$store
          .dispatch("orders/removeFromOrdersShipping", tempOrderArr)
          .then(() => {
            console.log("Order removed for shipping to DHL");
          });
      }

      this.updateSelectAll();

      // Select or deselect orders for various actions
      /** This code is when you want to use orders for different actions*/
      // let data = {};
      // data.action = selected == "no" ? "remove" : "add";
      // data.order = { id, orderNo };
      // this.$store.dispatch("orderRecords/addOrRemoveOrderRecord", data);
    },
    toggleItemVisiblity(order) {
      order.itemsVisible = !order.itemsVisible;
    },
    toggleOrderItems() {
      this.orders.forEach((order) => {
        order.itemsVisible = !order.itemsVisible;
      });
    },
    filteredOrder(order) {
      return {
        order_id: order.id,
        incoterm: order.incoterm,
        dhl_service: order.dhlService,
        weightTakenAfterPackaging: order.weightTakenAfterPackaging,
        packageDesc: order.packageDesc,
        shippingState: order.ShopifyShippingAddress
          ? order.ShopifyShippingAddress.province
          : "",
      };
    },
    downloadLabelsAsZip() {
      const selected = this.orders
        .filter(
          (order) => order.selected == `yes-${order.id}-${order.order_no}`
        )
        .map((order) => order.id);
      ShippingService.downloadShippingLabelsAsZip(selected)
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "labels.zip");
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((errors) => console.log(errors));
    },
    // Close-out by batch
    closeOutSelectedBatch() {
      let closeoutBatchArr = [];
      closeoutBatchArr = this.orders
        .filter(
          (order) =>
            order.selected == `yes-${order.id}-${order.order_no}` &&
            order.shippingBatch
        )
        .map((order) => order.shippingBatch);

      closeoutBatchArr = closeoutBatchArr.filter(
        (value, index) => closeoutBatchArr.indexOf(value) === index
      );

      if (closeoutBatchArr.length > 0) {
        CloseoutService.requestCloseout(closeoutBatchArr)
          .then((response) => {
            if (response) {
              this.$toasted.show(response.data.message, {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              });
            }
          })
          .catch((errors) => {
            console.log("error occured", errors);
            this.$toasted.show(errors.response.data.message, {
              type: "error",
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
          });
      } else {
        this.$toasted.show(
          "Please select a single record from the intended batch to closeout.",
          {
            type: "error",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 5000,
          }
        );
      }
    },
    showLogs(orderId) {
      EventBus.$emit("orders.show-logs", orderId);
    },
    deleteSelectedShippingRecords() {
      // Check if any record selected to take action or return error
      if (this.ordersCheckboxSelected.length == 0) {
        this.$toasted.show("Select some records to take this action", {
          type: "error",
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
          duration: 5000,
        });
      }

      let forShippingDelete = [];
      let closeOutComplete = [];
      let shippingNotDone = [];

      this.ordersCheckboxSelected.forEach((order) => {
        if (order.closeoutId) {
          closeOutComplete.push(order.orderNo);
        } else if (!order.shippingId) {
          shippingNotDone.push(order.orderNo);
        } else {
          forShippingDelete.push(order.shippingId);
        }
      });

      if (closeOutComplete.length > 0 || shippingNotDone.length > 0) {
        this.$toasted.show(
          `Following orders can't be processed as shipping not done for orders - ${shippingNotDone.join(
            ", "
          )} and closeout complete for orders - ${closeOutComplete.join(", ")}`,
          {
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
      }
      if (forShippingDelete.length > 0) {
        // proceed with the delete
        EventBus.$emit("should-show-loader", true);

        ShippingService.deleteShippingFromDhl(forShippingDelete)
          .then((response) => {
            this.$toasted.show(
              response.data.responseStatus.messageDetails[0].messageDetail,
              {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              }
            );
            EventBus.$emit("orders.bulk-fields-with-items-updated");
          })
          .catch((errors) => console.log(errors.response.data))
          .then(() => {
            EventBus.$emit("should-show-loader", false);
          });
      }
    },
    reprintLabelsForSelectedOrders() {
      console.log(this.ordersCheckboxSelected);

      let data = [];
      let missingData = [];

      if (this.ordersCheckboxSelected.length == 0) {
        this.$toasted.show("Select some records to take this action", {
          type: "error",
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
          duration: 5000,
        });
      }

      this.ordersCheckboxSelected.forEach((order) => {
        if (order.shippingId) {
          data.push(order.shippingId);
        } else {
          missingData.push(order.orderNo);
        }
      });
      // show notification
      if (missingData.length > 0) {
        let main_message =
          data.length == 0
            ? "Can't complete request"
            : "Fulfilled partial request";
        this.$toasted.show(
          `${main_message}. Shipping ID missing for orders - ${missingData.join(
            ", "
          )}`,
          {
            type: "error",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 10000,
          }
        );
      }
      if (data.length > 0) {
        EventBus.$emit("should-show-loader", true);

        ShippingService.reprintShippingLabelsFromDhl(data)
          .then((response) => {
            console.log(response.data);

            this.$toasted.show(
              response.data.responseStatus.messageDetails[0].messageDetail,
              {
                type: "success",
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
                duration: 5000,
              }
            );

            EventBus.$emit("orders.bulk-fields-with-items-updated");
          })
          .catch((errors) => {
            this.$toasted.show(errors.response.data.message, {
              type: "error",
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });
          })
          .then(() => {
            EventBus.$emit("should-show-loader", false);
          });
      }
    },
    showAllTags(actionType) {
      if (actionType === "show") {
        this.$root.$emit("bv::show::tooltip");
        this.showTags = true;
      } else {
        this.$root.$emit("bv::hide::tooltip");
        this.showTags = false;
      }
    },
    manageTagsModal(tags, id) {
      this.$bvModal.show("tags-modal");
      EventBus.$emit("order-tags", { tags, id });
    },
    customerFilesModal(items, order_no) {
      this.$bvModal.show("customer-files");
      EventBus.$emit("customer-files-modal-opened", { items, order_no });
    },
    showOrderTagLogsModal(orderId) {
      this.$bvModal.show("order-tag-logs");
      EventBus.$emit("order-tags-log-modal-opened", orderId);
    },
    showManageStatusModal(order) {
      this.$bvModal.show("statuses-modal");
      EventBus.$emit("order-statuses-modal-opened", order);
    },
    updateSingleValueFromOrderTable: debounce(async function(
      table,
      id,
      field,
      value
    ) {
      try {
        const updatedStatus = await OrdersService.singleValueUpdateOrderAndItems(
          {
            table,
            id,
            field,
            value,
          }
        );

        this.$toasted.show(updatedStatus.data.message, {
          type: "success",
          duration: 2000,
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      } catch (errors) {
        this.$toasted.show("Failed to update Tracking ID", {
          type: "error",
          duration: 2000,
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      }
    },
    1000),
    showTrackingData(orderId, orderNo, orderShippings) {
      console.log("See tracking data");
      EventBus.$emit("order.show-tracking-data", {
        orderId,
        orderNo,
        orderShippings,
      });
    },
    async updateTags(orderId, orderExistingTags, newTags) {
      const oldTags = orderExistingTags ? orderExistingTags.split(",") : [];
      let concatenatedArr = oldTags.concat(newTags);
      const combined = this.removeDuplicates(concatenatedArr);

      if (_.isEqual(_.sortBy(oldTags), _.sortBy(combined))) {
        this.$toasted.show("The tags already exists in the order", {
          type: "error",
          duration: 2000,
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      } else {
        let updateStatus = await OrderTagsService.updateOrderTags(
          orderId,
          combined
        );

        this.$toasted.show(updateStatus.data.message, {
          type: "success",
          duration: 2000,
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });

        EventBus.$emit("order-tag-updated", { id: orderId, tags: combined });
      }
    },
    removeDuplicates(data) {
      return data.filter((value, index) => data.indexOf(value) === index);
    },
    async getStoreWiseStatuses(storeId) {
      const result = await OrderStatusesService.fetchStoreWiseStatusList(
        storeId
      );

      this.itemStatusesOptions = result.data.statusList
        .filter((status) => {
          return status.forRecordType == "Item";
        })
        .map((status) => {
          return {
            value: status.id,
            text: status.title,
            colorCode: status.colorCode,
          };
        });
    },
    accessNote(recordId, noteType, orderNo = "") {
      EventBus.$emit("access-notes", { recordId, noteType, orderNo });
    },
    accessDraft(orderNo, orderId) {
      EventBus.$emit("accessed-customer-draft", { orderNo, orderId });
    },
    async fetchExtraStatus(storeId) {
      const extraStatus = await ExtraStatusService.fetchExtraStatus(storeId);
      this.extraStatuses = extraStatus.data.extraStatuses;
      EventBus.$emit("extra-statuses-fetched", this.extraStatuses);
    },
    showOrdersImportModal() {
      EventBus.$emit("initiated-import-order-from-excel", {
        storeId: this.data.store_id,
      });
      this.$bvModal.show("orders-import-modal");
    },
    resetDataObj() {
      this.data.store_id = null;
      this.data.searchTerm = null;
      this.data.statusSelected = null;
      this.data.extraStatuses = [];
      this.data.page = 1;
      this.data.count = 0;
    },
    async refreshOrder(id, shopifyId, storeId) {
      try {
        const refetchStatus = await OrdersService.refetchOrderFromShopify(
          id,
          shopifyId,
          storeId
        );

        this.$toasted.show(refetchStatus.data.message, {
          type: "success",
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
          duration: 5000,
        });

        EventBus.$emit("refetced-shopify-order", refetchStatus.data.theOrder);
      } catch (errors) {
        console.log(errors);
      }
    },
    showOrderEvents(orderPk) {
      EventBus.$emit("show-order-events-timeline", orderPk);
    },
    canBeAddedToPrintQueue(extraStatuses, activeExtraStatus) {
      const onHoldRecordId = extraStatuses.find(
        (exStat) => exStat.name == "On Hold"
      );

      if (onHoldRecordId) {
        const activeExtraStatusIdArray = activeExtraStatus.map((status) => {
          return status.id;
        });

        if (activeExtraStatusIdArray.includes(onHoldRecordId.id)) {
          return false;
        }
      }
      return true;
    },
  },
};
